import { ReactiveVar } from '@apollo/client'

/**
 * Persistent change listener for Apollo reactive vars.
 * @param rv ReactiveVar to listen to
 * @param listener The callback function to trigger on change
 */
export default function onReactiveVarChange<T>(
  rv: ReactiveVar<T>,
  listener: (value: T) => void,
) {
  let remove: () => void
  const wrappedListener = (value: T) => {
    listener(value)
    remove = rv.onNextChange(wrappedListener)
  }
  remove = rv.onNextChange(wrappedListener)

  return () => remove()
}
